/**
 * Волна B (docs/MIGRATION_ROUTER.md §5). Было: <CacheDataRoute path='/prizoteka-autumn'>.
 */
import { createFileRoute } from '@tanstack/react-router';
import CacheDataRoute from '../CacheDataRoute';
import Prizoteka2025 from '@routes/Prizoteka2025';

export const Route = createFileRoute('/prizoteka-autumn')({
  staticData: { layout: { landingFooter: true } },
  component: () => (
    <CacheDataRoute component={Prizoteka2025} path='/prizoteka-autumn' />
  )
});
